import { cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'focus:ring-ring inline-flex items-center justify-center shrink-0 rounded px-2.5 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/80 border-transparent',
        secondary:
          'bg-secondary text-secondary-foreground hover:bg-secondary/80 border-transparent',
        destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive/80 border-transparent',
        outline: 'text-foreground',
        danger: '',
        neutral: '',
        promotion: '',
        success: '',
        warning: '',
        attention: '',
        ai: '',
      },
      size: {
        default: 'h-5 min-w-5 min-h-5 space-x-1 p-1 !text-label-small',
        large: 'h-8 space-x-1 px-2 py-1.5 !text-label-default',
        icon: 'size-5 justify-center p-0',
        'large-icon': 'size-8 justify-center p-0',
      },
      badgeStyle: {
        subtle: 'border-none',
        bold: 'border-none',
        ghost: 'border-none',
      },
      // Enum labels are stored in sentence case; badges are the one place design wants Title Case.
      textCase: {
        none: '',
        title: 'capitalize',
      },
    },
    compoundVariants: [
      {
        variant: 'danger',
        badgeStyle: 'subtle',
        className: 'bg-main-background-subtle-semantic-danger text-main-foreground-danger',
      },
      {
        variant: 'danger',
        badgeStyle: 'bold',
        className: 'bg-main-background-danger text-main-foreground-inverse',
      },
      {
        variant: 'danger',
        badgeStyle: 'ghost',
        className: 'text-main-foreground-danger',
      },
      {
        variant: 'neutral',
        badgeStyle: 'subtle',
        className: 'bg-palette-opacity-gray-light text-main-foreground-secondary',
      },
      {
        variant: 'neutral',
        badgeStyle: 'bold',
        className: 'bg-main-background-contrast text-main-foreground-inverse',
      },
      {
        variant: 'neutral',
        badgeStyle: 'ghost',
        className: 'text-main-foreground-secondary',
      },
      {
        variant: 'promotion',
        badgeStyle: 'subtle',
        className: 'bg-main-background-subtle-semantic-accent text-main-foreground-accent',
      },
      {
        variant: 'promotion',
        badgeStyle: 'bold',
        className: 'bg-main-background-accent text-main-foreground-inverse',
      },
      {
        variant: 'promotion',
        badgeStyle: 'ghost',
        className: 'text-main-foreground-accent',
      },
      {
        variant: 'success',
        badgeStyle: 'subtle',
        className: 'bg-main-background-subtle-semantic-success text-main-foreground-success',
      },
      {
        variant: 'success',
        badgeStyle: 'bold',
        className: 'bg-main-background-success text-main-foreground-inverse',
      },
      {
        variant: 'success',
        badgeStyle: 'ghost',
        className: 'text-main-foreground-success',
      },
      {
        variant: 'warning',
        badgeStyle: 'subtle',
        className: 'bg-main-background-subtle-semantic-warning text-main-foreground-warning',
      },
      {
        variant: 'warning',
        badgeStyle: 'bold',
        className: 'bg-main-background-warning text-main-foreground-inverse',
      },
      {
        variant: 'warning',
        badgeStyle: 'ghost',
        className: 'text-main-foreground-warning',
      },
      {
        variant: 'attention',
        badgeStyle: 'subtle',
        className: 'bg-main-background-subtle-semantic-attention text-main-foreground-attention',
      },
      {
        variant: 'attention',
        badgeStyle: 'bold',
        className: 'bg-main-background-attention text-main-foreground-inverse',
      },
      {
        variant: 'attention',
        badgeStyle: 'ghost',
        className: 'text-main-foreground-attention',
      },
      {
        variant: 'ai',
        badgeStyle: 'subtle',
        className: 'bg-main-background-subtle-semantic-ai text-main-foreground-ai',
      },
      {
        variant: 'ai',
        badgeStyle: 'ghost',
        className: 'text-main-foreground-ai',
      },
      {
        variant: 'ai',
        badgeStyle: 'bold',
        className: 'bg-main-background-ai text-main-foreground-inverse',
      },
    ],
    defaultVariants: {
      variant: 'danger',
      size: 'default',
      badgeStyle: 'subtle',
      textCase: 'none',
    },
  },
)
